import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useI18n } from "@/i18n/I18nProvider";

export function FAQ() {
  const { t } = useI18n();
  const faqs = t.faq.items;
  return (
    <section id="faq" className="relative py-24 md:py-32">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 md:grid-cols-3 md:px-8">
        <div>
          <p className="font-mono-cinema text-[10px] text-gold">{t.faq.eyebrow}</p>
          <h2 className="mt-5 font-display text-4xl font-medium leading-[1.05] md:text-5xl">
            {t.faq.title1}
            <span className="block italic text-gold">{t.faq.title2}</span>
          </h2>
          <p className="mt-5 text-foreground/65">
            {t.faq.intro}
          </p>
        </div>
        <div className="md:col-span-2">
          <Accordion type="single" collapsible className="space-y-2.5">
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="overflow-hidden rounded-xl border border-border bg-card px-5 transition-colors data-[state=open]:border-gold/40 data-[state=open]:bg-card"
              >
                <AccordionTrigger className="py-5 text-left font-display text-base hover:no-underline md:text-lg">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-5 text-sm leading-relaxed text-foreground/70">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
